import { $playerProfile } from '../../../..//backend/store';
import Footer from '../footer/Footer';
import Avatar from './avatar/Avatar';
import Button from './button/Button';
import Marker from './marker/Marker';

const BG_PADDING_Y = 80;

const EVENTS = {
    HERO_SELECTED: 'hero_selected',
    SHOW: 'selector_show',
};

export default class Selector extends Phaser.GameObjects.Container {
    private selectedHeroId: number;

    private bg!: Phaser.GameObjects.Image;
    private marker!: Marker;
    // private alice!: Avatar;
    // private bob!: Avatar;

    private alice!: Button;
    private bob!: Button;

    constructor(scene: Phaser.Scene) {
        super(scene, 0, 0);

        this.selectedHeroId = 0;

        this.setupBG();
        this.setupButtons();
        this.setupListeners();

        this.setVisible(false);
    }

    static get EVENTS() {
        return EVENTS;
    }

    setupBG() {
        let x = this.scene.cameras.main.centerX;
        let y = this.scene.cameras.main.height - Footer.HEIGHT; // - BG_PADDING_Y;

        this.bg = this.scene.add.image(x, y, 'atlas', 'gui/selector/bg_new');
        this.bg.displayWidth = this.scene.cameras.main.width;
        this.bg.setOrigin(0.5, 1);
        this.add(this.bg);

        this.bg.setInteractive();
    }

    setupButtons(): void {
        const padding = 5;
        let x = this.bg.x - this.bg.displayWidth / 4 + padding;
        let y = this.bg.y - this.bg.displayHeight / 2;

        this.alice = new Button(this.scene, x, y, 0);
        this.add(this.alice);

        x = this.bg.x + this.bg.displayWidth / 4 - padding;

        this.bob = new Button(this.scene, x, y, 1);
        this.add(this.bob);

        this.alice.on('click', this.onHeroClick, this);
        this.bob.on('click', this.onHeroClick, this);
    }

    setupListeners(): void {
        this.scene.events.on(EVENTS.SHOW, this.show, this);
        // $playerProfile.watch((next) => {
        //     if (next.current_chapter >= 3) this.setVisible(true);
        // });
    }

    onHeroClick(button: Button): void {
        this.alice.deselect();
        this.bob.deselect();

        button.select();
        this.scene.events.emit(EVENTS.HERO_SELECTED, button.heroId);
    }

    onClick() {
        this.selectedHeroId++;
        if (this.selectedHeroId === 2) this.selectedHeroId = 0;
        this.marker.switch();

        this.scene.events.emit(EVENTS.HERO_SELECTED, this.selectedHeroId);
    }

    show(): void {
        this.setVisible(true);
    }

    destroy(fromScene?: boolean): void {
        this.scene.events.off(EVENTS.SHOW, this.show, this);
        super.destroy(fromScene);
    }
}
